import { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* NAVBAR */}
      <nav className="fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-4 sm:px-8 py-4 bg-gradient-to-r from-gray-900 to-black text-white shadow-lg border-b border-gray-800">
      <h1 className="text-base sm:text-xl font-bold tracking-tight text-white">
  <span className="text-emerald-400">MegaMind</span> Business Solutions
</h1>

        {/* DESKTOP LINKS */}
        <div className="hidden md:flex items-center gap-8">
          <Link 
            to="/" 
            className="text-gray-300 font-medium hover:text-green-400 transition-colors duration-200 relative group"
          >
            Home
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-green-400 transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link 
            to="/pricing" 
            className="text-gray-300 font-medium hover:text-green-400 transition-colors duration-200 relative group"
          >
            Pricing
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-green-400 transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link 
            to="/services" 
            className="text-gray-300 font-medium hover:text-green-400 transition-colors duration-200 relative group"
          >
            Services
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-green-400 transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link 
            to="/contact" 
            className="text-gray-300 font-medium hover:text-green-400 transition-colors duration-200 relative group"
          >
            Contact
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-green-400 transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <button className="bg-gradient-to-r from-green-500 to-green-600 text-white px-5 py-2 rounded-full font-medium hover:shadow-lg hover:shadow-green-500/25 hover:scale-105 transition-all duration-300">
            Get Started
          </button>
        </div>

        {/* HAMBURGER FOR MOBILE */}
        <button
          onClick={() => setOpen(true)}
          className="flex flex-col gap-1.5 md:hidden p-2 rounded-lg hover:bg-white/10 transition-colors"
        >
          <span className="w-6 h-0.5 bg-white transition-all"></span>
          <span className="w-6 h-0.5 bg-white transition-all"></span>
          <span className="w-6 h-0.5 bg-white transition-all"></span>
        </button>
      </nav>

      {/* OVERLAY */}
      <div
        className={`fixed inset-0 bg-black/70 backdrop-blur-sm z-40 transition-opacity duration-300 md:hidden ${
          open ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setOpen(false)}
      ></div>

      {/* MOBILE MENU */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-gradient-to-b from-gray-900 to-black z-50 transform transition-transform duration-300 ease-out md:hidden ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-6 border-b border-gray-800">
          <h2 className="font-bold text-lg text-white">Menu</h2>
          <button
            onClick={() => setOpen(false)}
            className="text-gray-400 text-2xl hover:text-white hover:rotate-90 transition-all duration-300"
          >
            ✕
          </button>
        </div>

        {/* Links */}
        <div className="flex flex-col px-6 py-8 gap-6">
          {[
            { name: "Home", link: "/" },
            { name: "Pricing", link: "/pricing" },
            { name: "Services", link: "/services" }, 
            { name: "Contact", link: "/contact" },
          ].map((item, idx) => (
            <Link
              key={idx}
              to={item.link}
              onClick={() => setOpen(false)}
              className="text-gray-300 text-lg font-medium hover:text-green-400 hover:translate-x-2 transition-all duration-200 border-b border-gray-800 pb-3"
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="absolute bottom-8 left-0 right-0 px-6">
          <button className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold shadow-lg shadow-green-500/25 hover:shadow-green-500/40 hover:scale-105 transition-all duration-300">
            Get Started
          </button>
          <p className="text-gray-500 text-xs text-center mt-3">© 2026 MegaMind Business Solutions</p>
        </div>
      </div>
    </>
  );
}